export default {
  namespaced  : true,

  state       : {
    images      : [],
    imageIndex  : null,
  },

  mutations   : {
    setImages(state, value){
      state.images = value;
    },

    setImageIndex(state, value){
      state.imageIndex = value;
    },

    resetStore(state){
      state.images      = [];
      state.imageIndex  = null;
    }
  },

  actions     : {
    updateImages(context, payload){
      context.commit('setImages',     payload.images);
      context.commit('setImageIndex', payload.imageIndex);
    },

    clearImages(context){
      context.dispatch({
        type        : 'updateImages',
        images      : [],
        imageIndex  : 0,
      });
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
};